import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FileUploadDrop from './file-upload-drop';
import FileUploadProgress from './file-upload-progress';


import Select from "../../common/components/forms/select";

import Button from '../../common/components/button';
import { Dialog } from '../../common/components/dialog';
import AlbumAddNew from '../../album-view/components/dialog/album-add-new';
import FileUploadCompleteContent from './dialog/file-upload-complete-content';
import { FileUploadPauseContent } from './dialog/file-upload-pause-upload-content';

import {
    allFilesCompleteClear,
    setCurrentUploadAlbum,
    pauseUpload,
    clearUploads,
    albumListRequested,
    setCancelUpload
} from '../../uploadController/actions/uploadController-actions';

import '../style/upload.scss';
import '../style/file-upload-status.scss';


import { requestAlbumListForSelection } from '../../album-view/actions/album-actions';
import { clearUploadItems , toggleIsCancelDownloadDialogOpen, continueUpload, stopUpload, uploadsComplete} from '../../upload/actions/upload-actions';

export class FileUploadContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedAlbumName: '',
            albumsLoading: false,
            albumListIsDirty: false,
            isAlbumListRequested: false,
            isAddAlbumDialogOpen: false,
            isUploadCompleteDialogOpen: false,
            isSupportedTypesOpen: false,
        };

        this.setSelectedAlbumId = this.setSelectedAlbumId.bind(this);
        this.openAddAlbumDialog = this.openAddAlbumDialog.bind(this);
        this.loadSelectionAlbums = this.loadSelectionAlbums.bind(this);
        this.openFileUploadCompleteDialog = this.openFileUploadCompleteDialog.bind(this);
        this.closeFileUploadCompleteDialog = this.closeFileUploadCompleteDialog.bind(this);
        this.setNewSelectedAlbum = this.setNewSelectedAlbum.bind(this);
        this.isSupportedTypesOpen = this.isSupportedTypesOpen.bind(this);
        this.stopUploads = this.stopUploads.bind(this);
        this.continueUploads = this.continueUploads.bind(this);
        if(props.uploadAlbumIdDrop === -1 && props.albumSelection.length > 0){
            setTimeout(()=> this.setNewSelectedAlbum())
        }
        this.loadCount = 0;
    }

    componentDidMount() {
        //this.loadSelectionAlbums();
        //this.props.loadAlbumSelectList(this.props.albums);
        //	this.props.albumListRequested();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.uploadAlbumIdDrop === -1 && nextProps.albumSelection.length > 0){
            setTimeout(()=> this.setNewSelectedAlbum())
        }
    }

    componentDidUpdate(prevProps) {
        const { uploadComplete, allFilesCompleteClear, filesInProcess } = this.props;

        if (uploadComplete) {
            allFilesCompleteClear();
            this.setState({ isUploadCompleteDialogOpen: true });

        }
        if ((prevProps.filesInProcess.length === 0) && (filesInProcess.length > 0)) {
            this.setState({ isUploadCompleteDialogOpen: false });
        }

        if (this.state.albumListIsDirty && !this.state.albumsLoading) {
            this.setState({ albumsLoading: true });
            //this.props.requestAlbumsForSelection();
        }

    }

    setNewSelectedAlbum() {
        const { albumSelection } = this.props;
        if (albumSelection.length > 0) {
            const albumId = albumSelection[0].key;
            const albumName = albumSelection[0].label;


            this.setState({
                albumsLoading: false,
                albumListIsDirty: false,
                selectedAlbumId: albumId,
                selectedAlbumName: albumName
            });

            this.props.setCurrentUploadAlbum(albumId, albumName);
        }

    }

    openAddAlbumDialog() {
        this.setState({ isAddAlbumDialogOpen: true });
    }

    isSupportedTypesOpen() {
        this.setState({ isSupportedTypesOpen: true });
    }

    openFileUploadCompleteDialog() {
        const { completeUploads, filesToUpload } = this.props;

        if (completeUploads.length & !filesToUpload.length) {
            this.setState({ isUploadCompleteDialogOpen: true });
        }
    }

    closeFileUploadCompleteDialog() {
        this.setState({ isUploadCompleteDialogOpen: false });
    }

    loadSelectionAlbums() {
        this.setState({
            albumsLoading: false,
            albumListIsDirty: true
        });
    }

    setSelectedAlbumId({field,value}) {

        const { setCurrentUploadAlbum, albumSelection } = this.props;
        var selectedOption = albumSelection[this.albumSelect.selectedIndex];


        const albumId = selectedOption.key;
        const albumName = selectedOption.label;
        this.setState({
            selectedAlbumId: albumId,
            selectedAlbumName: albumName
        });

        setCurrentUploadAlbum(albumId, albumName);
    }


    stopUploads() {
        this.props.toggleIsCancelDownloadDialogOpen();
        this.props.setUploadsComplete();
        //this.setState({isCancelDownloadDialogOpen:false,
        //	uploadComplete: true});
        this.props.clearUploadsController();
        this.props.setCancelUpload(true);
        this.props.stopUpload();

    }

    continueUploads() {
        this.props.pauseUpload();
        this.props.toggleIsCancelDownloadDialogOpen();
    }


    render() {

        return (
            <div className="upload-container">
                <div className="upload-album-selection-container">
                    <h1>Upload to:</h1>

                    <Select
                        className="select-album-dropdown"
                        onChange={this.setSelectedAlbumId}
                        value={this.props.uploadAlbumIdDrop}
                        refCallback={albumSelect => (this.albumSelect = albumSelect)}
                        disabled={this.state.albumsLoading || this.props.filesInProcess.length > 0}
                        options={this.props.albumSelection}

                    />


                    <div className="upload-album-add-button" onClick={this.openAddAlbumDialog}>
                        <div className="header-icon add-to-album" />
                        <div className="new-album-label">Add New Album</div>
                    </div>
                </div>
                <FileUploadDrop
                    selectedAlbumId={this.props.uploadAlbumIdDrop}
                    disabled={this.props.uploadAlbumIdDrop === -1}
                    onAlbumNotSelected={this.openAddAlbumDialog}
                    albumId={this.props.uploadAlbumIdDrop}
                />
                <div className="supportedFormats-container">
                    <div className="supportedFormats" onClick={this.isSupportedTypesOpen}>
                        <div className="upload"></div>
                        Supported Formats
                    </div>
                </div>
                <FileUploadProgress
                    onUploadComplete={this.openFileUploadCompleteDialog}
                    filesToUpload={this.props.filesToUpload}
                    completeUploads={this.props.completeUploads}

                />
                <div className="file-upload-item-container" ref="test">
                </div>


                <div className="digitize-container">
                    <div className="digitize-icon" />
                    <p className="section-text">
                        iMemories will professionally digitize your vintage home movie films, camcorder videotapes, photos & slides.
                    </p>
                    {/*<Button className="btn-digitize imem-button primamry" buttonLabel="Digitize Analog Memories" buttonStyle="primary" />*/}
					<a href="/my/upload/digitize-kit" className="btn-digitize imem-button primary">Digitize Analog Memories</a>
                </div>

                <div className="app-container">
                    <div className="app-icon" />
                    <p className="section-text">
                        Install our iPhone and iPad mobile apps to auto-upload photos and videos stored on your mobile devices.
                    </p>
                    <a href="https://itunes.apple.com/us/app/imemories/id528388477?mt=8" target="_blank" className="btn-app"></a>
                </div>

                <div className="install-container">
                    <div className="install-icon" />
                    <p className="section-text">
                        Install our Android phone and tablet apps to auto-upload photos and videos stored on your mobile devices.
                    </p>
                    <a href="https://play.google.com/store/apps/details?id=com.imemories.android&feature=search_result#?t=W251bGwsMSwxLDEsImNvbS5pbWVtb3JpZXMuYW5kcm9pZCJd" target="_blank" className="btn-install"></a>
                </div>


                {/*<div className="import-container">*/}
                {/*<div className="import-icon" />*/}
                {/*<p className="section-text">*/}
                {/*Import your photos and videos curently stored in other places like Facebook, Instagram and Dropbox.*/}
                {/*</p>*/}
                {/*<div className="btn-import">Import From Other Places</div>*/}
                {/*</div>*/}

                {this.state.isAddAlbumDialogOpen &&
                <Dialog
                    onClose={() => this.setState({ isAddAlbumDialogOpen: false })}
                    title="Add New Album"
                    isOpen={this.state.isAddAlbumDialogOpen}>
                    <AlbumAddNew onCancel={() => this.setState({ isAddAlbumDialogOpen: false })} />
                </Dialog>
                }
                {this.state.isSupportedTypesOpen &&
                <Dialog
                    onClose={() => this.setState({ isSupportedTypesOpen: false })}
                    title="Supported Formats"
                    isOpen={this.state.isSupportedTypesOpen}>
                    <React.Fragment>
                        <div className="SupportedText" >
                            <p>
                                <br/>
                                <span className="title">Photo formats supported:</span><br/>
                                JPG, JPEG, HEIF, TIF, TIFF, BMP, GIF, PNG
                            </p>
                            <p>
                                <span className="title">Video formats supported:</span><br/>
                                MP4, MTS, MOV, AVI, DV, MPG, MPEG, M4V, WMV
                            </p>
                        </div>
                        <div className="btn-dialog-container">
                            <Button buttonStyle="primary" className="btn-dialog-2" buttonLabel="OK" onClick={() => this.setState({ isSupportedTypesOpen: false })} />
                        </div>
                    </React.Fragment>
                </Dialog>
                }
                {
                    this.state.isUploadCompleteDialogOpen &&
                    <Dialog onClose={() => this.setState({ isUploadCompleteDialogOpen: false })}
                            isOpen={this.state.isUploadCompleteDialogOpen}
                            title="Upload Complete"
                    >
                        <FileUploadCompleteContent
                            albumName={this.state.selectedAlbumName}
                            albumId={this.props.uploadAlbumIdDrop}
                            closeDialog={() => this.setState({ isUploadCompleteDialogOpen: false })}

                        />
                    </Dialog>
                }
                {this.props.isCancelDownloadDialogOpen &&
                <Dialog isOpen={this.props.isCancelDownloadDialogOpen}
                        onClose={this.continueUploads}>

                    <FileUploadPauseContent yesClick={this.stopUploads} noClick={this.continueUploads} />
                </Dialog>
                }
            </div >
        );
    }
}
FileUploadContainer.propTypes = {
    fileChangeHandler: PropTypes.func,
    requestAlbumsForSelection: PropTypes.func,
    clearUploads: PropTypes.func,
    history: PropTypes.shape({
        listen: PropTypes.func
    }),
    filesToUpload: PropTypes.array,

    setCurrentUploadAlbum: PropTypes.func,
    completeUploads: PropTypes.array,
    filesInProcess: PropTypes.array,
    uploadComplete: PropTypes.bool,
    allFilesCompleteClear: PropTypes.func,
    uploadAlbumIdDrop: PropTypes.number,
    albumSelection: PropTypes.array,
    isCancelDownloadDialogOpen: PropTypes.bool,
    toggleIsCancelDownloadDialogOpen: PropTypes.func,
    pauseUpload: PropTypes.func,
    stopUpload: PropTypes.func,
    setUploadsComplete: PropTypes.func,
    clearUploadsController: PropTypes.func,
    loadAlbumSelectList: PropTypes.func,
    albumListRequested: PropTypes.func,
    albums: PropTypes.array,
    setCancelUpload: PropTypes.func,
    uploadAlbumId: PropTypes.number

};

const mapStateToProps = state => {
    return {
        //	albumSelection: state.albumList.albums.map(album => {return ({key: album.id,label: album.title})}),
        albumSelection: state.uploadController.albumSelectList,
        albums: state.albumList.albums,
        filesToUpload: state.uploadController.filesToUpload,
        filesInProcess: state.uploadController.filesInProcess,
        completeUploads: state.uploadController.filesComplete,
        uploadComplete: state.uploadController.uploadComplete,
        uploadAlbumIdDrop: state.uploadController.uploadAlbumIdDrop,
        isCancelDownloadDialogOpen: state.upload.isCancelDownloadDialogOpen
    };
};

const mapDispatchToProps = dispatch => {
    return {
        requestAlbumsForSelection: (offset = 0, max = 100) => {
            requestAlbumListForSelection(dispatch, offset, max);
        },
        clearUploads: () => {
            dispatch(clearUploadItems());
        },

        clearUploadsController: () => {
            dispatch(clearUploads());
        },

        setCurrentUploadAlbum: (albumId, albumName) => {
            dispatch(setCurrentUploadAlbum(albumId, albumName));
        },
        allFilesCompleteClear: () => { dispatch(allFilesCompleteClear()); },
        toggleIsCancelDownloadDialogOpen: () => dispatch(toggleIsCancelDownloadDialogOpen()),
        pauseUpload: () => dispatch(pauseUpload()),
        continueUpload: () => dispatch(continueUpload()),
        stopUpload: () => dispatch(stopUpload()),
        setCancelUpload: (state) => dispatch(setCancelUpload(state)),
        setUploadsComplete: () => dispatch(uploadsComplete()),
        //loadAlbumSelectList: (albums) => dispatch(loadAlbumSelectList(albums)),
        albumListRequested: (offset = 0) => {
            dispatch(albumListRequested(dispatch, offset, false, 2, true));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUploadContainer);



// WEBPACK FOOTER //
// ./src/upload/components/file-upload-container.jsx